import styled from 'styled-components'
import {NavLink} from '@components/lib'
import Avatar from '@mui/material/Avatar'

export const Container = styled(NavLink)`
  justify-content: flex-start;
  height: auto;
  margin: 0;

  ${({theme}) => theme.breakpoints.down('tabletL')} {
    margin-bottom: 27px;

    &:after {
      height: auto;
      left: auto;
      right: -15px;
      top: 0;
      width: 7px;
    }
  }
`

export const ProfileAvatar = styled(Avatar)`
  margin-right: 15px;
  width: 40px;
  height: 40px;
  flex: none;
  background: ${({theme}) => theme.colors.primary};
`

export const InfoCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const Name = styled.span`
  display: inline-block;
  font-size: ${({theme}) => theme.fontSizes.small};
  font-family: ${({theme}) => theme.fontFamilies.title};
  width: 125px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${({theme}) => theme.breakpoints.down('tabletL')} {
    font-size: ${({theme}) => theme.fontSizes.default};
    font-weight: 600;
    width: 180px;
  }
`

export const Balance = styled.span`
  color: ${({theme}) => theme.colors.green};
  font-size: ${({theme}) => theme.fontSizes.extraSmall};
`
